<template>
  <v-card-title class="px-6 py-4 d-flex align-center" v-if="header">
    <span class="text-h5 d-flex align-center">
      <slot name="prepend-button"></slot>
      <v-icon v-if="prependHeaderIcon" class="mr-2">{{ prependHeaderIcon }}</v-icon>
      {{ header }}
    </span>
    <v-spacer></v-spacer>
    <!-- @slot header actions -->
    <slot name="header-actions"></slot>
    <v-btn
      variant="text"
      density="comfortable"
      class="ml-2"
      icon
      @click="$emit('close')"
      v-if="!hideCloseIcon">
      <slot name="close-icon">
        <v-icon>mdi-close</v-icon>
      </slot>
    </v-btn>
  </v-card-title>
</template>

<script>
/**
 * Styled dialog header
 * @displayName Dialog Header
 */
export default {
  props: {
    /**
     * Dialog header
     */
    header: {
      type: String,
      required: true
    },
    prependHeaderIcon: {
      type: String,
      required: false,
      default: ''
    },
    hideCloseIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      /**
       * Emits close event
       * @event close
       */
      this.$emit('close');
    }
  }
};
</script>
